import { gql } from '@apollo/client'

export const GET_CONTENT_COLLECTIONS = gql`
  query GetContentCollections($ids: [ID!]!, $first: Int, $after: String) {
    contentCollections(ids: $ids) {
      id
      title
      connection(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          attribution
          node {
            __typename
            ... on Node {
              id
            }
            ... on ContentSeries {
              id
              project {
                id
                slug
                releaseDate
                highestScore
              }
              firstWatchable {
                __typename
                ... on ContentEpisode {
                  id
                  watchableAvailabilityStatus
                }
              }
            }
            ... on ContentMovie {
              id
              watchableAvailabilityStatus
              project {
                id
                slug
                releaseDate
                highestScore
              }
            }
            ... on ContentSpecial {
              id
              watchableAvailabilityStatus
              posterCloudinaryPath
              project {
                id
                slug
                releaseDate
                highestScore
              }
            }
            ... on ContentEpisode {
              id
              watchableAvailabilityStatus
              project {
                id
                slug
                releaseDate
                highestScore
              }
            }
            ... on ContentSeason {
              id
              seasonNumber
              project {
                id
                slug
                releaseDate
                highestScore
              }
              episodes(first: 1) {
                edges {
                  node {
                    id
                    watchableAvailabilityStatus
                  }
                }
              }
            }
            ... on ContentDisplayable {
              id
              name
              genres
              ratings
              description(version: SHORT)
              posterTitleImage: image(aspect: "2:3", category: TITLE_ART) {
                aspect
                category
                cloudinaryPath
              }
              landscapeTitleImage: image(aspect: "16:9", category: TITLE_ART) {
                aspect
                category
                cloudinaryPath
              }
              posterNonTitleImage: image(aspect: "2:3", category: NON_TITLE_ART) {
                aspect
                category
                cloudinaryPath
              }
              landscapeNonTitleImage: image(aspect: "16:9", category: NON_TITLE_ART) {
                aspect
                category
                cloudinaryPath
              }
              landscapeBackdropImage: image(aspect: "16:9", category: BACKDROP) {
                aspect
                category
                cloudinaryPath
              }
              squareNonTitleImage: image(aspect: "1:1", category: NON_TITLE_ART) {
                aspect
                category
                cloudinaryPath
              }
              posterStillImage: image(aspect: "2:3", category: STILL_1) {
                aspect
                category
                cloudinaryPath
              }
              landscapeStillImage: image(aspect: "16:9", category: STILL_1) {
                aspect
                category
                cloudinaryPath
              }
              portraitAngelImage: image(aspect: "2:3", category: ANGEL_KEY_ART_1) {
                aspect
                category
                cloudinaryPath
              }
              landscapeAngelImage: image(aspect: "16:9", category: ANGEL_KEY_ART_1) {
                aspect
                category
                cloudinaryPath
              }
              logoImage: image(aspect: "original", category: LOGO) {
                aspect
                category
                cloudinaryPath
              }
            }
          }
        }
      }
    }
  }
`
export const GET_WATCH_COLLECTION_CONTENT = gql`
  query GetWatchCollectionContent($ids: [ID!]!, $first: Int, $after: String) {
    contentCollections(ids: $ids) {
      id
      title
      connection(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            __typename
            ... on Node {
              id
            }
            ... on ContentMovie {
              id
              slug
              movieSubtitle: subtitle
              duration
              watchableAt
              releaseDate
              watchableAvailabilityStatus
              project {
                id
                slug
                releaseDate
              }
              posterLandscapeCloudinaryPath
              landscapeTitleImage: image(aspect: "16:9", category: TITLE_ART) {
                cloudinaryPath
              }
              landscapeAngelImage: image(aspect: "16:9", category: ANGEL_KEY_ART_1) {
                cloudinaryPath
              }
              landscapeStillImage: image(aspect: "16:9", category: STILL_1) {
                cloudinaryPath
              }
              watchPosition {
                position
              }
              description
              name
            }
            ... on ContentEpisode {
              id
              slug
              subtitle
              episodeNumber
              duration
              watchableAt
              releaseDate
              watchableAvailabilityStatus
              project {
                id
                slug
                releaseDate
              }
              watchPosition {
                position
              }
              posterLandscapeCloudinaryPath
              landscapeStillImage: image(aspect: "16:9", category: STILL_1) {
                cloudinaryPath
              }
              description
              name
            }
          }
        }
      }
    }
  }
`
